import { render, staticRenderFns } from "./nijmegen.vue?vue&type=template&id=78d7e9e8"
import script from "./nijmegen.vue?vue&type=script&lang=js"
export * from "./nijmegen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports